import { useDispatch } from 'react-redux';
import { unSetUserToken } from '../../storage/features/authSlice';
import { unsetUserInfo } from '../../storage/features/userSlice';
import { removeToken, removeUserInfo } from '../../storage/LocalStorageService';
import { useQueryClient } from '@tanstack/react-query';
import usePopupMsg from '../../hooks/usePopupMsg';

const LogoutButton = ({ translation }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  
  const handleLogout = () => {
    // Clear Redux and local storage
    dispatch(unsetUserInfo({ name: "", email: "" }));
    dispatch(unSetUserToken({ access_token: null }));
    removeToken();
    removeUserInfo();

    // Clear React Query cache
    queryClient.clear();

    usePopupMsg.getState().open("Logout successfully", "success");
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
    }

    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  return (
    <button onClick={handleLogout} className="px-3">
      {translation.logout}
    </button>
  );
};

export default LogoutButton;
